"use client"
import React from "react"
import BaseHeader from "@/app/components/base/BaseHeader"

export default function Header({comparatorStyle = false}: {comparatorStyle?: boolean} = {}) {
    if (comparatorStyle) {
        return <BaseHeader comparatorStyle />
    }

    return (
        <BaseHeader
            start={["Logo"]}
            center={["Nav"]}
            end={["Actu"]}
        />
    )
}
